/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespHeroCarousel_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user" | "PdpRespIconBubblesWrapper_user" | "ViewInRoomImage_user" | "ViewInRoomImageCredits_user">;
    readonly " $refType": "PdpRespHeroCarousel_user";
};
export type PdpRespHeroCarousel_user$data = PdpRespHeroCarousel_user;
export type PdpRespHeroCarousel_user$key = {
    readonly " $data"?: PdpRespHeroCarousel_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImageCredits_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'bbd3bfc84c30e17fe912c6ac083b9cc3';
export default node;
